export interface PropertyTypeOption {
  slug: string;
  label: string;
  enabled: boolean;
  categoryId: number;
}

export const propertyTypeOptions: PropertyTypeOption[] = [
  {
    slug: "private-office",
    label: "Private Office",
    categoryId: 1,
    enabled: true,
  },
  {
    slug: "proposal",
    label: "Propostas",
    categoryId: 5,
    enabled: true,
  },
];

export const getDefaultPropertyType = (): string[] => {
  return [propertyTypeOptions[0].slug];
};

export const getCategoryIdFromPropertyType = (
  propertyType: string,
): number[] => {
  const categoryId = propertyTypeOptions.find(
    (option) => option.slug === propertyType,
  )?.categoryId;
  return categoryId ? [categoryId] : [1];
};
